import React from 'react'
import { Skeleton, ConfigProvider, Space, Flex} from 'antd'

const OfferCardSkeleton:React.FC = () => {
  const [imageWidth, setImageWidth] = React.useState(200);

  React.useEffect(() => {
    const updateWidth = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 350) setImageWidth(90);
      else if (screenWidth <= 370) setImageWidth(100);
      else if (screenWidth <= 390) setImageWidth(130);
      else if (screenWidth <= 410) setImageWidth(150);
      else if (screenWidth <= 430) setImageWidth(170);
      else setImageWidth(180);
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);
  return (
    <ConfigProvider
      theme={{
      components: {
        Skeleton: {
        gradientFromColor: "#404040",
        gradientToColor:"#606060"
        },
      },
    }}>
      <div className='w-full rounded-[10px] bg-[#606060] h-full p-2 '>
        <Flex justify="center" align="center">
            <Space direction="vertical" size="small">
              <Skeleton.Image
                active
                style={{ width: `${imageWidth}px`, height: "110px" }}
              />
              <Skeleton.Input size='small' style={{ width: `${imageWidth}px`, height: "20px" }} active/>
              <Skeleton.Input size='small' style={{ width: `${imageWidth}px`, height: "20px" }} active/>
              <Skeleton.Input size='small' style={{ width: `${imageWidth}px`, height: "20px" }} active/>
            </Space>
        </Flex>
      </div>
    </ConfigProvider>
  )
}

export default OfferCardSkeleton